import React from 'react';
export function useEventsForDate(events, date) {
    return React.useMemo(() => {
        return events.filter((event) => event.date.equals(date));
    }, [events, date]);
}
export function useEventsForMonth(events, month) {
    return React.useMemo(() => {
        const endDay = month.startDay + month.dayCount;
        return events.filter((event) => {
            return (event.date.year === month.year &&
                event.date.day >= month.startDay &&
                event.date.day < endDay);
        });
    }, [events, month]);
}
//# sourceMappingURL=useEventsForDate.js.map